// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove overflow:hidden from the main content box */
.shared-popup .mapboxgl-popup-content {
  background: linear-gradient(160deg, rgba(23,38,49,0.97) 0%, rgba(12,17,32,0.97) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--map-border);
  border-top: 1px solid var(--map-border-focus);
  border-radius: 14px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3), 0 12px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(199,194,194,0.07);
  padding: 0;
  overflow: visible; /* ← was hidden */
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  animation: sharedPopupIn 0.18s ease;
  width: 330px !important;
}

/* Style the close button to float above the popup */
.shared-popup .mapboxgl-popup-close-button {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--map-bg);
  border: 1px solid var(--map-border-focus);
  color: var(--map-text-muted);
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  z-index: 10;
}

.shared-popup .mapboxgl-popup-close-button:hover {
  background: var(--map-danger);
  color: #ffffff;
  border-color: var(--map-danger);
}
@keyframes sharedPopupIn {
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0)   scale(1);    }
}

.shared-popup .mapboxgl-popup-tip {
  border-top-color: rgba(12,17,32,0.97);
}

/* ── Loading ── */
.sp-loading {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgba(199,194,194,0.5); /* --map-text-muted at 50% */
  font-size: 11px;
  letter-spacing: 0.05em;
}

.sp-spinner {
  width: 14px;
  height: 14px;
  border: 1.5px solid rgba(199,194,194,0.15); /* --map-border dimmed */
  border-top-color: var(--map-danger);         /* #EE5B43 accent */
  border-radius: 50%;
  animation: sp-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes sp-spin { to { transform: rotate(360deg); } }

/* ── Rows ── */
.sp-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 9px 14px;
  border-bottom: 1px solid rgba(199,194,194,0.08); /* --map-border softened */
  transition: background 0.15s ease;
}

.sp-row:last-child { border-bottom: none; }
.sp-row:hover { background: var(--map-surface-hover); }

/* ── Label ── */
.sp-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sp-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sp-label-text {
  font-size: 11px;
  font-weight: 400;
  color: var(--map-text-muted);   /* #c7c2c2 */
  text-transform: uppercase;
  letter-spacing: 0.07em;
  white-space: nowrap;
}

/* ── Value ── */
.sp-value-wrap {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.sp-value {
  font-size: 13px;
  font-weight: 650;
  color: var(--map-text-primary); /* #ffffff */
  letter-spacing: 0.02em;
  font-feature-settings: 'tnum';
}

.sp-unit {
  font-size: 13px;
  font-weight: 500;
  color: var(--map-text-muted);   /* #c7c2c2 */
  letter-spacing: 0.04em;
}`, "",{"version":3,"sources":["webpack://./src/utils/popup/SharedPopupStyle.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,qFAAqF;EACrF,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,6CAA6C;EAC7C,mBAAmB;EACnB,wGAAwG;EACxG,UAAU;EACV,iBAAiB,EAAE,iBAAiB;EACpC,uFAAuF;EACvF,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,mCAAmC,KAAK;AAC7D;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B,EAAE,4BAA4B;EAC1D,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C,EAAE,wBAAwB;EACpE,mCAAmC,UAAU,mBAAmB;EAChE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,+CAA+C,EAAE,0BAA0B;EAC3E,iCAAiC;AACnC;;AAEA,qBAAqB,mBAAmB,EAAE;AAC1C,gBAAgB,oCAAoC,EAAE;;AAEtD,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B,IAAI,YAAY;EAC5C,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B,EAAE,YAAY;EAC5C,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B,IAAI,YAAY;EAC5C,sBAAsB;AACxB","sourcesContent":["/* Remove overflow:hidden from the main content box */\n.shared-popup .mapboxgl-popup-content {\n  background: linear-gradient(160deg, rgba(23,38,49,0.97) 0%, rgba(12,17,32,0.97) 100%);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--map-border);\n  border-top: 1px solid var(--map-border-focus);\n  border-radius: 14px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.3), 0 12px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(199,194,194,0.07);\n  padding: 0;\n  overflow: visible; /* ← was hidden */\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  animation: sharedPopupIn 0.18s ease;\n  width: 330px !important;\n}\n\n/* Style the close button to float above the popup */\n.shared-popup .mapboxgl-popup-close-button {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--map-bg);\n  border: 1px solid var(--map-border-focus);\n  color: var(--map-text-muted);\n  font-size: 14px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  z-index: 10;\n}\n\n.shared-popup .mapboxgl-popup-close-button:hover {\n  background: var(--map-danger);\n  color: #ffffff;\n  border-color: var(--map-danger);\n}\n@keyframes sharedPopupIn {\n  from { opacity: 0; transform: translateY(6px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0)   scale(1);    }\n}\n\n.shared-popup .mapboxgl-popup-tip {\n  border-top-color: rgba(12,17,32,0.97);\n}\n\n/* ── Loading ── */\n.sp-loading {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: rgba(199,194,194,0.5); /* --map-text-muted at 50% */\n  font-size: 11px;\n  letter-spacing: 0.05em;\n}\n\n.sp-spinner {\n  width: 14px;\n  height: 14px;\n  border: 1.5px solid rgba(199,194,194,0.15); /* --map-border dimmed */\n  border-top-color: var(--map-danger);         /* #EE5B43 accent */\n  border-radius: 50%;\n  animation: sp-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes sp-spin { to { transform: rotate(360deg); } }\n\n/* ── Rows ── */\n.sp-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 9px 14px;\n  border-bottom: 1px solid rgba(199,194,194,0.08); /* --map-border softened */\n  transition: background 0.15s ease;\n}\n\n.sp-row:last-child { border-bottom: none; }\n.sp-row:hover { background: var(--map-surface-hover); }\n\n/* ── Label ── */\n.sp-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sp-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.sp-label-text {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--map-text-muted);   /* #c7c2c2 */\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  white-space: nowrap;\n}\n\n/* ── Value ── */\n.sp-value-wrap {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n}\n\n.sp-value {\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--map-text-primary); /* #ffffff */\n  letter-spacing: 0.02em;\n  font-feature-settings: 'tnum';\n}\n\n.sp-unit {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--map-text-muted);   /* #c7c2c2 */\n  letter-spacing: 0.04em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
